module.exports = __webpack_public_path__ + "public/StoreIcon/groceryorderTwo.svg?97919705";